export enum CasePreviewCardType {
  NO_DEAL = 'NO_DEAL',
  HAS_DEAL = 'HAS_DEAL',
  CASE_OPENED = 'CASE_OPENED',
}
